var app = angular.module('registerApp', [
    'ngComponentRouter',
    'registerAppServices',
    'registerAppComponents',
    'registerAppDirectives',
    'ui.select',
    'ngSanitize',
    'vsGoogleAutocomplete'
]);

app.config(['$locationProvider', function($locationProvider) {
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false
        });
    }])
    .value('$routerRootComponent', 'root');
